module.exports = __webpack_public_path__ + "static/media/danelectro.5e444d44.jpeg";